import React, { useState } from "react";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import ZipGameStepper from "../../components/ZipGameStepper";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { zipSendOtpApi } from "../../http/http";
import { toast } from "react-toastify";
import SmallLoader from "../../components/Loaders/SmallLoader";

const RegisterZipGame = () => {
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState("");

  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  const handleNext = async () => {
    if (!msisdn.trim()) return;
    try {
      setLoading(true);
      const response = await zipSendOtpApi(msisdn);
      console.log(response, 'response--');
      setLoading(false);

      navigate("/verify-otp/zip-game", {
        state: { msisdn },
      });
    } catch (error) {
      setLoading(false);

      console.log(error?.response, 'error');
      if (error?.response?.data?.status == 0) {
        toast.error(t("87"));
      }
      else {
        toast.error(t("86"));
      }
    }
  };

  return (
    <>
      <Header />

      <div className={classes.container}>

        <div className={classes.header_section}>
          <div className={classes.back_button} onClick={() => {
            navigate("/");
          }}>
            <FaArrowLeft className={classes.back_icon} />
          </div>
        </div>


        <div className={classes.heroCard}>
          <div className={classes.heroBadge}>ZIP GAME</div>
          <h1 className={classes.heroTitle}>{t("178")}</h1>
          <p className={classes.heroText}>
            {t("179")}
          </p>
        </div>

        <ZipGameStepper currentStep={1} />

        <div className={classes.formCard}>
          <div className={classes.section}>
            <div className={classes.sectionHead}>
              <h2 className={classes.sectionTitle}>{t("180")}</h2>
              <p className={classes.sectionText}>
                {t("181")}
              </p>
            </div>

            <div className={classes.inputGroup}>
              <label className={classes.label} htmlFor="msisdn">
                {t("182")}
              </label>

              <div className={classes.phoneField}>
                <div className={classes.countryBox}>
                  <img
                    src="/assets/images/gabon.png"
                    alt="flag"
                    className={classes.flag}
                  />
                  <span className={classes.code}>+241</span>
                </div>

                <input
                  id="msisdn"
                  type="number"
                  className={classes.input}
                  placeholder={t("183")}
                  value={msisdn}
                  onChange={(e) => setMsisdn(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>

            <div className={classes.infoBox}>
              <p>
                {t("184")}
              </p>
            </div>

            <button type="button" className={classes.primaryBtn} onClick={handleNext} disabled={loading}>
              {loading ? <SmallLoader /> : t("185")}
            </button>

            {/* here it will be the login option */}
            {/* <p className={classes.link_text}>
              {t("186")}{" "}<span onClick={() => navigate("/login/zip-game")}>{t("187")}</span>
            </p> */}

          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterZipGame;